export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* 회사 정보 */}
          <div>
            <h3 className="text-white font-bold text-xl mb-4">화악산 포도즙</h3>
            <p className="text-sm leading-relaxed mb-4">
              경기도 최고봉 화악산의 청정 자연에서<br />
              정직하게 만든 저온 착즙 포도즙
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-[#6B4E9C] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-[#6B4E9C] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-[#6B4E9C] transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* 고객 지원 */}
          <div>
            <h4 className="text-white font-bold mb-4">고객 지원</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="hover:text-white transition-colors cursor-pointer">주문 조회</a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors cursor-pointer">배송 안내</a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors cursor-pointer">교환/환불</a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors cursor-pointer">FAQ</a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors cursor-pointer">고객센터</a>
              </li>
            </ul>
          </div>

          {/* 정보 */}
          <div>
            <h4 className="text-white font-bold mb-4">정보</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="hover:text-white transition-colors cursor-pointer">회사 소개</a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors cursor-pointer">검사성적서</a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors cursor-pointer">인증서</a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors cursor-pointer">생산 공정</a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors cursor-pointer">농장 소개</a>
              </li>
            </ul>
          </div>

          {/* 연락처 */}
          <div>
            <h4 className="text-white font-bold mb-4">연락처</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-[#6B4E9C] mt-1 flex-shrink-0"></i>
                <div>
                  <p className="font-semibold text-white">고객센터</p>
                  <p>1588-XXXX</p>
                  <p className="text-xs text-gray-400">평일 09:00 - 18:00</p>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-[#6B4E9C] mt-1 flex-shrink-0"></i>
                <div>
                  <p className="font-semibold text-white">이메일</p>
                  <p>support@example.com</p>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-[#6B4E9C] mt-1 flex-shrink-0"></i>
                <div>
                  <p className="font-semibold text-white">주소</p>
                  <p>경기도 가평군 북면 화악산로 XXX</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* 인증 및 보증 */}
        <div className="border-t border-gray-800 pt-8 mb-8">
          <div className="flex flex-wrap items-center justify-center gap-8 mb-6">
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-award-line text-[#6B4E9C] text-xl"></i>
              <span>무농약 인증</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-shield-check-line text-[#6B4E9C] text-xl"></i>
              <span>HACCP 인증</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-file-list-3-line text-[#6B4E9C] text-xl"></i>
              <span>검사성적서 공개</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-recycle-line text-[#6B4E9C] text-xl"></i>
              <span>유기질 퇴비 재배</span>
            </div>
          </div>
        </div>

        {/* 사업자 정보 */}
        <div className="border-t border-gray-800 pt-8 text-sm text-gray-400">
          <div className="grid md:grid-cols-2 gap-4 mb-6">
            <div>
              <p><strong className="text-gray-300">상호:</strong> (주)화악산농원</p>
              <p><strong className="text-gray-300">대표:</strong> 홍길동</p>
              <p><strong className="text-gray-300">사업자등록번호:</strong> 123-45-67890</p>
            </div>
            <div>
              <p><strong className="text-gray-300">통신판매업신고:</strong> 제2024-경기가평-0001호</p>
              <p><strong className="text-gray-300">개인정보관리책임자:</strong> 김철수</p>
            </div>
          </div>

          <div className="flex flex-wrap gap-6 mb-6">
            <a href="#" className="hover:text-white transition-colors cursor-pointer">이용약관</a>
            <a href="#" className="hover:text-white transition-colors cursor-pointer font-bold">개인정보처리방침</a>
            <a href="#" className="hover:text-white transition-colors cursor-pointer">환불정책</a>
            <a href="#" className="hover:text-white transition-colors cursor-pointer">원문 성적서</a>
          </div>

          <div className="flex flex-wrap items-center justify-between gap-4 pt-6 border-t border-gray-800">
            <p>© 2024 화악산 포도즙. All rights reserved.</p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}